export default __webpack_public_path__ + "static/media/bloodbath5.81989e0b.png";